import UserService from '../../services/UserService'

export default function authorization({ router, next, to }) {
    if (!to.meta.permissions) {
        return next();
    }
    let permissions = Array.isArray(to.meta.permissions) ? to.meta.permissions : [to.meta.permissions];
    
    if (permissions.every( section => UserService.getPermissions().indexOf(section) > -1 )) {
        return next();
    }

    return router.push({ name: 'Forbidden' });
}